/**
 * Condiciones de sesión para pasos condicionales (showIf) de los tutoriales.
 *
 * Las sesiones de carga persisten en localStorage (SessionContext) y quedan
 * abiertas INDEFINIDAMENTE hasta que se cierran explícito (botón Salir del
 * formulario) o se inicia una nueva. Al aterrizar en /animals/new con una
 * sesión abierta que tiene animales, aparece el SessionActiveModal en lugar
 * del selector de campos: los tutoriales de sesión (tacto, pesajes, balanza,
 * lector) muestran entonces un paso extra que señala el botón "Nueva Sesión"
 * de ese modal.
 *
 * Pura y sync (lee localStorage directo): los módulos de tutorial son datos
 * sin hooks — mismo patrón que completionCheck.
 */

/** Claves de SessionContext (ver SESSION_STORAGE_KEYS en src/contexts/SessionContext.tsx). */
const SESSION_CODE_KEY = 'animal_session_code';
const SESSION_ANIMALS_KEY = 'animal_session_animals';

/**
 * True si hay una sesión de carga abierta CON animales cargados. Una sesión
 * vacía no cuenta: al aterrizar en /animals/new se descarta sola y abre una
 * nueva, así que el paso condicional no haría falta.
 */
export const sesionAbiertaConAnimales = (): boolean => {
  try {
    if (!localStorage.getItem(SESSION_CODE_KEY)) return false;
    const raw = localStorage.getItem(SESSION_ANIMALS_KEY);
    if (!raw) return false;
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0;
  } catch {
    return false;
  }
};
